import type { UcServiceId } from './usercentricsConfig';
import { useUsercentricsContext } from './UsercentricsContext';

export const useServiceConsent = (serviceId: UcServiceId): boolean | null => {
  const { isCmpEnabled, isInitialized, consents } = useUsercentricsContext();

  if (!isCmpEnabled) {
    return isInitialized ? true : null;
  }

  if (!isInitialized) {
    return null;
  }

  if (!(serviceId in consents)) {
    return false;
  }

  return consents[serviceId];
};
